var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00C44A",
    opacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5648_22648)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.034 10c5.969 0 10.804 3.91 10.804 8.746 0 1.852-.72 3.6-2.367 5.35-2.264 2.675-7.306 5.761-8.437 6.276-.992.36-.956-.148-.932-.487q.005-.072.006-.13c0-.206.103-.926.103-.926.103-.206.103-.617 0-.926-.086-.259-.464-.373-.765-.465l-.16-.05c-5.249-.72-9.056-4.32-9.056-8.642C9.23 13.909 14.066 10 20.034 10m7.51 11.318c0 .104-.102.206-.204.206h-2.984c-.102 0-.206-.103-.206-.207v-4.733c0-.102.104-.205.207-.205h2.983c.102 0 .206.103.206.205v.72c0 .103-.104.206-.207.206h-2.057v.825h2.058c.102 0 .206.103.206.205v.722c0 .102-.104.204-.207.204h-2.057v.824h2.058c.102 0 .205.102.205.206zm-11.214 0c0 .104-.103.206-.205.206H13.14c-.102 0-.206-.102-.206-.206v-4.733c0-.102.104-.205.205-.205h.721c.103 0 .206.103.205.204v3.706h2.059c.102 0 .205.102.205.206zm.926-4.938h.721c.103 0 .205.103.205.205v4.733c0 .104-.102.206-.205.206h-.721c-.103 0-.205-.102-.205-.206v-4.733c0-.102.102-.205.205-.205m5.144 0h.722c.103 0 .204.102.407.306l.003.003v4.733c0 .102-.102.206-.205.206h-.823l-.103-.104-2.161-2.88v2.778c0 .102-.102.204-.206.204h-.72c-.103 0-.206-.102-.206-.204v-4.734c0-.103.103-.205.207-.205h.72l2.16 2.88v-2.778c0-.102.103-.205.205-.205",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5648_22648"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.23 10h21.538v21.538H9.23z"
  })))));
};
export default SvgLine;